import {
    MonetizationOn,
    Calculate,
    QueryStats,
    RequestQuote,
    Diversity3,
    NextWeek,
    Extension,
    FolderShared,
    SupervisorAccount,
    FollowTheSigns,
    AccountBalanceWallet,
    Receipt,
    OnDeviceTraining,
    Addchart,
    SsidChart,
    Rule,
    CurrencyExchange,
    Dashboard,
    Payments,
    Settings,
    AccountBalance,
    Power,
} from "@mui/icons-material";

import { NavigationItem } from "./types";

export const navigationItems: NavigationItem[] = [
    {
        id: "comercial",
        text: "Comercial",
        icon: <MonetizationOn />,
        permission: "comercial.visualizar",
        subItems: [
            {
                text: "Propostas",
                url: "/comercial/proposal",
                icon: <NextWeek />,
                permission: "propostas.listar",
            },
            {
                text: "Propostas de Implementações",
                url: "/comercial/implementationProposal",
                icon: <Extension />,
                permission: "propostas.listar",
            },
            {
                text: "Acompanhamento",
                url: "/comercial/acompanhamento",
                icon: <FollowTheSigns />,
                permission: "projetos.visualizar",
            },
        ],
    },
    {
        id: "financial",
        text: "Financeiro",
        icon: <Calculate />,
        permission: "financeiro",
        subItems: [
            {
                text: "Titulares",
                url: "/comercial/holders",
                icon: <SupervisorAccount />,
                permission: "titulares.listar",
            },
            {
                text: "Central de Clientes",
                url: "/financial/clientes/central",
                icon: <FolderShared />,
                permission: "clientes.central",
            },
            {
                text: "Faturas Mensais",
                url: "/financial/faturas-mensais",
                icon: <AccountBalanceWallet />,
                permission: "nota.fiscal.listar",
            },
            {
                text: "Notas Fiscais",
                url: "/financial/invoices",
                icon: <Receipt />,
                permission: "nota.fiscal.listar",
            },
            {
                text: "Produção",
                url: "/financial/production",
                icon: <OnDeviceTraining />,
                permission: "relatorios.producao.listar",
            },
            {
                text: "Clientes",
                url: "/comercial/customers",
                icon: <FolderShared />,
                permission: "titulares.listar",
            },
        ],
    },
    {
        id: "reports",
        text: "Relatórios",
        icon: <QueryStats />,
        permission: "relatorios.visualizar",
        subItems: [
            {
                text: "Novo relatório",
                url: "/reports/listagem-relatorios/geracao-relatorios",
                icon: <Addchart />,
                permission: "relatorio.criar",
            },
            {
                text: "Relatórios gerados",
                url: "/reports/listagem-relatorios",
                icon: <SsidChart />,
                permission: "relatorio.listar",
            },
            {
                text: "Validações",
                url: "/reports/validations",
                icon: <Rule />,
                permission: "validators.listar",
            },
        ],
    },
    {
        id: "comissions",
        text: "Comissões",
        icon: <RequestQuote />,
        permission: "comissoes.visualizar",
        subItems: [
            {
                text: "Configuração",
                url: "/comissions/comissionSetup",
                icon: <CurrencyExchange />,
                permission: "comissoes.visualizar",
            },
        ],
    },
    {
        id: "acquirer",
        text: "Adquirente App",
        icon: <AccountBalance />,
        permission: "acquirer.menu",
        subItems: [
            {
                text: "Dashboard",
                url: "/acquirer/dashboard",
                icon: <Dashboard />,
                // permission: "acquirer.dashboard.view",
                permission: "acquirer.menu",
            },
            {
                text: "Cliente/App",
                url: "/acquirer/app-customer",
                icon: <Diversity3 />,
                permission: "acquirer.menu",
                // permission: "acquirer.app-customer.view",
            },
            {
                text: "Solicitações de saque",
                url: "/acquirer/withdrawals",
                icon: <Payments />,
                permission: "acquirer.menu",
                // permission: "acquirer.withdrawals.view",
            },
            {
                text: "Integrações",
                url: "/acquirer/integrations",
                icon: <Power />,
                permission: "acquirer.menu",
                // permission: "acquirer.withdrawals.view",
            },
        ],
    },
];
